import _styled, { default as _styled2 } from "styled-components";
import React from "react";
import { Pattern } from "~/features/app/pattern";
import { Wrap } from "~/features/ui/wrap";
import { type Mode } from "~/features/ui/get-theme-style";
import { ScrollHighlightText } from "~/features/ui/scroll-highlight-text";
type SectionDataAttrs = Record<`data-${string}`, string | undefined>;
export type ShopStatementBlockViewProps = {
  anchor?: {
    id?: string | null;
    name?: string | null;
  } | null;
  hasTopDivider?: boolean | null;
  mode?: string | null;
  theme?: string | null;
  headline?: string | null;
  sectionProps?: React.ComponentPropsWithoutRef<"section"> & SectionDataAttrs;
};

/**
 * Shop landing closing statement: a centered two-tone (scroll-highlight) line on
 * a squared/grid background. Shop-scoped so the grid pattern lives here rather
 * than on the shared `highlightHeadline` section. Light/dark follows `data-theme`.
 */
export function ShopStatementBlockView({
  anchor,
  hasTopDivider = true,
  mode = "light",
  theme = "white",
  headline,
  sectionProps
}: ShopStatementBlockViewProps) {
  return <_StyledSection {...sectionProps} data-theme={mode as Mode} id={anchor?.id || undefined} data-anchor-name={anchor?.name || undefined} $_css={[{
    "position": "relative",
    "color": "var(--text-primary)"
  }, theme === "grey" ? {
    "backgroundColor": "var(--bg-tertiary)"
  } : {
    "backgroundColor": "var(--bg-primary)"
  }, hasTopDivider && {
    "borderTopWidth": "1px",
    "borderColor": "var(--stroke-primary)"
  }]}>
      <Pattern pattern="grid" />
      <Wrap mode={mode as Mode}>
        <_StyledDiv $_css2={[{
        "position": "relative",
        "zIndex": "10",
        "display": "flex",
        "flexDirection": "column",
        "alignItems": "center",
        "gap": "var(--spacing-xl)",
        "paddingLeft": "var(--spacing-lg)",
        "paddingRight": "var(--spacing-lg)",
        "paddingTop": "var(--spacing-3xl)",
        "paddingBottom": "var(--spacing-3xl)",
        "textAlign": "center",
        "@media (min-width: 1024px)": {
          "padding": "var(--spacing-4xl)"
        }
      }]}>
          {headline && <ScrollHighlightText text={headline} />}
        </_StyledDiv>
      </Wrap>
    </_StyledSection>;
}
var _StyledSection = /*#__PURE__*/_styled("section").withConfig({
  componentId: "sc-sf-q5msjn-0"
})`${p => p.$_css}`;
var _StyledDiv = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "shop-statement___StyledDiv",
  componentId: "sc-1d6aakw-0"
})(["", ""], p => p.$_css2);